/**
 * Constantes do veículo elétrico do catálogo próprio (at-54, itens 57 e 58).
 *
 * ⚠️ **Por que isto existe (item 58):** ao escolher um modelo do catálogo, a tela
 * preenchia modelo, valor protegido, combustível e câmbio — mas **não o tipo de
 * veículo**. E o consultor não tinha como corrigir: o modal de tipo filtra por uma
 * lista fixa de 12 códigos no backend (`codigoPuxar`), que **não inclui o 35**.
 * Resultado: o veículo era cadastrado como carro/moto comum, e junto vinham **cota,
 * produtos e rateio do perfil errado**.
 *
 * E o SGA **aceita** isso sem reclamar — sondado em 07/09/2026 (veículo de teste
 * 96649): ele gravou uma motocicleta elétrica como *"PASSEIO EXCLUSIVE 0425"*, com cota
 * de passeio e modelo *"IMP / H. DAVIDSON 1977"*. Não havia erro para avisar ninguém.
 *
 * 📌 O backend **impõe** o tipo 35 de qualquer forma (`prepararCarroBike`). A tela
 * define o mesmo valor porque ele é usado ANTES do envio: é o tipo que filtra a lista
 * de cotas. Sem isso, o consultor escolheria a cota errada mesmo com o cadastro certo.
 */

/** `SgaTipoVeiculo.codigo_tipo` de "MOTOCICLETA - ELÉTRICA". Espelha `TIPO_VEICULO_BIKE_SGA` do backend. */
export const TIPO_VEICULO_ELETRICO = '35';

/**
 * Rótulo exibido nas telas. Fonte única — é por aqui que o item 57 (o rename de
 * "bicicleta elétrica" para "motocicleta elétrica") mantém o vocabulário coerente,
 * em vez de repetir a mesma string em cada tela.
 */
export const TIPO_VEICULO_ELETRICO_NOME = 'MOTOCICLETA - ELÉTRICA';

/** Como o produto é chamado na interface, no singular. */
export const ROTULO_VEICULO_ELETRICO = 'Motocicleta elétrica';
